/**
 * One-shot flag set by the stamp's pointerdown dismiss handler and consumed
 * (read + reset) by the canvas click handler. Avoids re-opening the mobile
 * context menu on the same tap that dismissed it.
 */
let dismissed = false;

export function markMobileMenuDismissed(): void {
    dismissed = true;
}

export function consumeMobileMenuDismissed(): boolean {
    const was = dismissed;
    dismissed = false;
    return was;
}
